export default __webpack_public_path__ + "static/media/icon3.6936afa1.png";